import * as React from 'react';
import { observer } from 'mobx-react';

import CreateProjectModal from 'shared/newContainers/selectors/ProjectSelector/CreateProjectModal';
import { Button } from 'shared/newComponents/buttons';
import { usePermissionsStore } from 'stores/index';
import { useModalState } from 'shared/entities/common/hooks';
import { PlusIcon } from 'shared/newComponents/icons';
import { ButtonColor, ButtonSize } from 'shared/newEntities/components/Button';
import { ComponentType } from 'shared/entities/components/Component';
import { PopupPosition } from 'shared/entities/components/Popup';
import { useTypedTranslation } from 'shared/entities/localization';
import Reference from 'shared/newComponents/Reference';

type Props = {
  collapsed?: boolean;
};

const CreateProjectButton: React.FC<Props> = ({ collapsed }: Props) => {
  const permissionsStore = usePermissionsStore();
  const modalState = useModalState();
  const { t } = useTypedTranslation('newContainers');

  const title = t('ProjectSelector.topItem.title');

  const button = React.useMemo(() => {
    return (
      <Button
        fullWidth
        disabled={!permissionsStore.canCreateProject}
        type={ComponentType.button}
        onClick={modalState.open}
        size={collapsed ? ButtonSize.md : ButtonSize.xxl}
        Icon={PlusIcon}
        color={ButtonColor.lightBlue}
      >
        {collapsed ? null : title}
      </Button>
    );
  }, [permissionsStore.canCreateProject, modalState.open, title, collapsed]);

  return (
    <>
      <CreateProjectModal
        opened={modalState.opened}
        onClose={modalState.close}
      />
      {collapsed ? (
        <Reference
          trigger={<div>{button}</div>}
          title={title}
          position={[PopupPosition.rightCenter]}
        />
      ) : (
        button
      )}
    </>
  );
};

export default observer(CreateProjectButton);
